import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { Observable } from 'rxjs';
import { TrainOperatingCompaniesResponse } from '../models/train-operating-company.model';

@Injectable({ providedIn: 'root' })
export class TrainOperatingCompaniesService extends BaseApiService {
  getAllTrainOperatingCompanies(): Observable<TrainOperatingCompaniesResponse[]> {
    return this.get<TrainOperatingCompaniesResponse[]>('/train-operating-companies');
  }
}
